@if (displayable && (displayable.displayOptions.active || defaultVisible || defaultHidden)) {
  <div class="style-preview" [class.disabled]="disabled" (click)="openStylePickerDialog()">
    <app-tooltip-wrapper [noPadding]="true" [border]="'around'" [right]="right" [rowStyle]="true">
      @if ((displayable.displayOptions.active && hidden) || (!displayable.displayOptions.active && defaultHidden) || forceHidden) {
        <span class="icon icon-eye-blocked"></span>
      } @else if (!displayable.displayOptions.active) {
        <span class="icon icon-eye"></span>
      } @else if (cosmeticOptions) {
        @if (cosmeticOptions.highlight && cosmeticOptions.minimapIconShape) {
          <app-minimap-icon [cosmeticOptions]="cosmeticOptions"></app-minimap-icon>
        } @else if (cosmeticOptions && cosmeticOptions.highlight && cosmeticOptions.beam) {
          <app-highlight-beam-icon [highlightColor]="cosmeticOptions.highlightColor!"></app-highlight-beam-icon>
        } @else {
          <span class="icon icon-eye"></span>
        }
      }
      <ng-template #tooltip>
        <div class="label-background" [style.background-image]="labelBackgroundImage()">
          <div class="item-label">
            <div app-label-viewer [displayOptions]="displayable.displayOptions" [exampleName]="exampleName" [forceHidden]="forceHidden"
              [isCurrency]="isCurrency" [isWaystone]="isWaystone" [isPoe1Gem]="isPoe1Gem" [isQuestItem]="isQuestItem" [rarity]="rarity" [disableBackground]="true" [sockets]="sockets"
              [influence]="influence" [fractured]="fractured" [veiled]="veiled"></div>
          </div>
        </div>
      </ng-template>
    </app-tooltip-wrapper>
  </div>

  @if (dialogOpen) {
    <app-style-picker-dialog
      (close)="closeStylePickerDialog()"
      (styleUpdated)="setCosmeticOptionsFromDisplayOptions(); styleUpdated.emit();"
      [isCurrency]="isCurrency"
      [displayable]="displayable"
      [exampleName]="exampleName"
      [isWaystone]="isWaystone"
      [isPoe1Gem]="isPoe1Gem"
      [isQuestItem]="isQuestItem"
      [rarity]="rarity"
      [sockets]="sockets"
      [influence]="influence"
      [fractured]="fractured"
      [veiled]="veiled"
      [allowDisactivate]="allowDisactivate"
      [allowHide]="allowHide"
      [title]="title"></app-style-picker-dialog>
  }
}
